import { render, staticRenderFns } from "./DeqCurrency.vue?vue&type=template&id=a8ba1b18&scoped=true"
import script from "./DeqCurrency.vue?vue&type=script&lang=js"
export * from "./DeqCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ba1b18",
  null
  
)

export default component.exports